/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Medme Analytics Reports API
 * API для генерации PDF/XLSX отчетов по аналитике медицинских клиник.

Все отчеты генерируются асинхронно в фоновом режиме. 
После создания задачи вы получаете `jobId` (UUID), по которому можно отслеживать статус и скачать готовый файл.

**Типы отчетов:**
- Общие показатели
- KPI по записям
- Подтверждение записи
- Отмена записи
- Статистика по виджету
- Статистика по отзывам
- Статистика по источникам записей

 * OpenAPI spec version: 1.0.0
 */

import type { RequestHandlerOptions } from "msw"
import { delay, HttpResponse, http } from "msw"

import type {
	AppointmentConfirmationResponse,
	AppointmentsKpiResponse,
	BookingSourcesResponse,
	GeneralAppointmentsResponse,
	ReviewsFunnelResponse,
	WidgetFunnelResponse,
} from ".././types"

export const getGetWidgetFunnelDataResponseMock = (): WidgetFunnelResponse => ({
	metricType: "events",
	period: {
		startDate: "2025-05-01",
		endDate: "2025-05-07",
		detalization: "day",
	},
	table: {
		columns: [
			{
				key: "step",
				label: "analytics.widgetFunnel.columns.step",
				align: "left",
			},
			{
				key: "eventCount",
				label: "analytics.widgetFunnel.columns.eventCount",
				align: "right",
			},
			{
				key: "conversionRate",
				label: "analytics.widgetFunnel.columns.conversionRate",
				align: "right",
			},
		],
		data: [
			{
				step: "widgetLoaded",
				eventCount: "5 200",
				conversionRate: "100%",
				rawValues: { eventCount: 5200, conversionRate: 100 },
			},
			{
				step: "serviceSelected",
				eventCount: "4 100",
				conversionRate: "79%",
				rawValues: { eventCount: 4100, conversionRate: 79 },
			},
			{
				step: "branchSelected",
				eventCount: "3 950",
				conversionRate: "76%",
				rawValues: { eventCount: 3950, conversionRate: 76 },
			},
			{
				step: "doctorSelected",
				eventCount: "3 100",
				conversionRate: "60%",
				rawValues: { eventCount: 3100, conversionRate: 60 },
			},
			{
				step: "timeSelected",
				eventCount: "2 200",
				conversionRate: "55%",
				rawValues: { eventCount: 2200, conversionRate: 55 },
			},
			{
				step: "reserveSuccess",
				parent: "timeSelected",
				eventCount: "1 750",
				conversionRate: "40%",
				rawValues: { eventCount: 1750, conversionRate: 40 },
			},
			{
				step: "reserveError",
				parent: "timeSelected",
				eventCount: "120",
				conversionRate: "2%",
				rawValues: { eventCount: 120, conversionRate: 2 },
			},
			{
				step: "codeRequested",
				eventCount: "1 710",
				conversionRate: "35%",
				rawValues: { eventCount: 1710, conversionRate: 35 },
			},
			{
				step: "codeEntered",
				parent: "codeRequested",
				eventCount: "1 600",
				conversionRate: "20%",
				rawValues: { eventCount: 1600, conversionRate: 20 },
			},
			{
				step: "appointmentCreated",
				eventCount: "1 710",
				conversionRate: "35%",
				rawValues: { eventCount: 1710, conversionRate: 35 },
			},
			{
				step: "appointmentConfirmed",
				parent: "appointmentCreated",
				eventCount: "1 600",
				conversionRate: "20%",
				rawValues: { eventCount: 1600, conversionRate: 20 },
			},
			{
				step: "appointmentError",
				parent: "appointmentCreated",
				eventCount: "60",
				conversionRate: "1%",
				rawValues: { eventCount: 60, conversionRate: 1 },
			},
		],
	},
	chart: {
		legend: [
			{
				name: "analytics.legend.widgetLoaded",
				key: "widgetLoaded",
				color: "#3b82f6",
			},
			{
				name: "analytics.legend.serviceSelected",
				key: "serviceSelected",
				color: "#ef4444",
			},
			{
				name: "analytics.legend.branchSelected",
				key: "branchSelected",
				color: "#f97316",
			},
			{
				name: "analytics.legend.doctorSelected",
				key: "doctorSelected",
				color: "#f59e0b",
			},
			{
				name: "analytics.legend.timeSelected",
				key: "timeSelected",
				color: "#10b981",
			},
			{
				name: "analytics.legend.appointmentCreated",
				key: "appointmentCreated",
				color: "#06b6d4",
			},
		],
		data: [
			{
				name: "2025-05-01",
				widgetLoaded: 300,
				serviceSelected: 200,
				branchSelected: 80,
				doctorSelected: 80,
				timeSelected: 80,
				appointmentCreated: 80,
			},
			{
				name: "2025-05-03",
				widgetLoaded: 250,
				serviceSelected: 180,
				branchSelected: 70,
				doctorSelected: 65,
				timeSelected: 60,
				appointmentCreated: 55,
			},
			{
				name: "2025-05-05",
				widgetLoaded: 280,
				serviceSelected: 190,
				branchSelected: 75,
				doctorSelected: 70,
				timeSelected: 65,
				appointmentCreated: 60,
			},
			{
				name: "2025-05-07",
				widgetLoaded: 320,
				serviceSelected: 220,
				branchSelected: 85,
				doctorSelected: 80,
				timeSelected: 75,
				appointmentCreated: 70,
			},
			{
				name: "2025-05-09",
				widgetLoaded: 350,
				serviceSelected: 240,
				branchSelected: 90,
				doctorSelected: 85,
				timeSelected: 80,
				appointmentCreated: 75,
			},
		],
	},
})

export const getGetReviewsFunnelDataResponseMock =
	(): ReviewsFunnelResponse => ({
		period: {
			startDate: "2025-05-01",
			endDate: "2025-05-07",
			detalization: "day",
		},
		table: {
			columns: [
				{
					key: "branch",
					label: "analytics.reviews.columns.branch",
					align: "left",
				},
				{
					key: "sent",
					label: "analytics.reviews.columns.sent",
					align: "right",
				},
				{
					key: "delivered",
					label: "analytics.reviews.columns.delivered",
					align: "right",
				},
				{
					key: "opened",
					label: "analytics.reviews.columns.opened",
					align: "right",
				},
				{
					key: "reviewLeft",
					label: "analytics.reviews.columns.reviewLeft",
					align: "right",
				},
				{
					key: "avgRating",
					label: "analytics.reviews.columns.avgRating",
					align: "right",
				},
			],
			data: [
				{
					branch: "Филиал 1, г. Омск",
					sent: "140",
					delivered: "30",
					opened: "10",
					reviewLeft: "20",
					avgRating: "4,7",
					rawValues: {
						sent: 140,
						delivered: 30,
						opened: 10,
						reviewLeft: 20,
						avgRating: 4.7,
					},
				},
				{
					branch: "Филиал 2, г. Санкт-Петербург",
					sent: "140",
					delivered: "30",
					opened: "10",
					reviewLeft: "20",
					avgRating: "4,8",
					rawValues: {
						sent: 140,
						delivered: 30,
						opened: 10,
						reviewLeft: 20,
						avgRating: 4.8,
					},
				},
			],
		},
		chart: {
			legend: [
				{ name: "analytics.legend.sent", key: "sent", color: "#a855f7" },
				{ name: "analytics.legend.opened", key: "opened", color: "#3b82f6" },
				{
					name: "analytics.legend.reviewLeft",
					key: "reviewLeft",
					color: "#eab308",
				},
			],
			data: [
				{ name: "2025-05-01", sent: 320, opened: 260, reviewLeft: 50 },
				{ name: "2025-05-02", sent: 300, opened: 280, reviewLeft: 95 },
				{ name: "2025-05-03", sent: 340, opened: 200, reviewLeft: 135 },
				{ name: "2025-05-04", sent: 280, opened: 150, reviewLeft: 25 },
				{ name: "2025-05-05", sent: 310, opened: 200, reviewLeft: 130 },
				{ name: "2025-05-06", sent: 270, opened: 80, reviewLeft: 65 },
				{ name: "2025-05-07", sent: 240, opened: 60, reviewLeft: 20 },
			],
		},
	})

export const getGetAppointmentConfirmationDataResponseMock =
	(): AppointmentConfirmationResponse => ({
		period: {
			startDate: "2025-05-01",
			endDate: "2025-05-07",
			detalization: "day",
		},
		type: "confirm",
		table: {
			columns: [
				{
					key: "branch",
					label: "analytics.appointmentConfirmation.confirm.columns.branch",
					align: "left",
				},
				{
					key: "sent",
					label: "analytics.appointmentConfirmation.confirm.columns.sent",
					align: "right",
				},
				{
					key: "delivered",
					label: "analytics.appointmentConfirmation.confirm.columns.delivered",
					align: "right",
				},
				{
					key: "opened",
					label: "analytics.appointmentConfirmation.confirm.columns.opened",
					align: "right",
				},
				{
					key: "actionResult",
					label:
						"analytics.appointmentConfirmation.confirm.columns.actionResult",
					align: "right",
				},
				{
					key: "errors",
					label: "analytics.appointmentConfirmation.confirm.columns.errors",
					align: "right",
				},
			],
			data: [
				{
					branch: "Филиал 1, г. Омск",
					sent: "140",
					delivered: "30",
					opened: "10",
					actionResult: "20",
					errors: "20",
					rawValues: {
						sent: 140,
						delivered: 30,
						opened: 10,
						actionResult: 20,
						errors: 20,
					},
				},
				{
					branch: "Филиал 2, г. Санкт-Петербург",
					sent: "140",
					delivered: "30",
					opened: "10",
					actionResult: "20",
					errors: "20",
					rawValues: {
						sent: 140,
						delivered: 30,
						opened: 10,
						actionResult: 20,
						errors: 20,
					},
				},
			],
		},
		chart: {
			legend: [
				{
					name: "analytics.legend.confirm.sent",
					key: "sent",
					color: "#a855f7",
				},
				{
					name: "analytics.legend.confirm.opened",
					key: "opened",
					color: "#3b82f6",
				},
				{
					name: "analytics.legend.confirm.actionResult",
					key: "actionResult",
					color: "#eab308",
				},
			],
			data: [
				{ name: "2025-05-01", sent: 320, opened: 260, actionResult: 50 },
				{ name: "2025-05-02", sent: 300, opened: 280, actionResult: 95 },
				{ name: "2025-05-03", sent: 340, opened: 200, actionResult: 135 },
				{ name: "2025-05-04", sent: 280, opened: 150, actionResult: 25 },
				{ name: "2025-05-05", sent: 310, opened: 200, actionResult: 130 },
				{ name: "2025-05-06", sent: 270, opened: 80, actionResult: 65 },
				{ name: "2025-05-07", sent: 240, opened: 60, actionResult: 20 },
			],
		},
	})

export const getGetBookingSourcesDataResponseMock =
	(): BookingSourcesResponse => ({
		period: {
			startDate: "2025-05-01",
			endDate: "2025-05-07",
			detalization: "day",
		},
		totalBookings: 3331,
		chart: {
			legend: [
				{
					name: "analytics.legend.sources.WIDGET_ONLINE",
					key: "WIDGET_ONLINE",
					color: "#a855f7",
				},
				{
					name: "analytics.legend.sources.ALLIANZ",
					key: "ALLIANZ",
					color: "#3b82f6",
				},
				{
					name: "analytics.legend.sources.ALOL_TNT_APP",
					key: "ALOL_TNT_APP",
					color: "#f97316",
				},
				{
					name: "analytics.legend.sources.ANDROID_APP",
					key: "ANDROID_APP",
					color: "#eab308",
				},
				{
					name: "analytics.legend.sources.BACKOFFICE_SUPER_ADMIN_CALL",
					key: "BACKOFFICE_SUPER_ADMIN_CALL",
					color: "#f43f5e",
				},
				{
					name: "analytics.legend.sources.BACKOFFICE_SUPER_ADMIN_FLOW",
					key: "BACKOFFICE_SUPER_ADMIN_FLOW",
					color: "#22c55e",
				},
				{ name: "analytics.legend.sources.BME", key: "BME", color: "#10b981" },
				{ name: "ANY_SOURCE", key: "ANY_SOURCE", color: "#9333EA" },
			],
			data: [
				{
					name: "2025-05-01",
					WIDGET_ONLINE: 520,
					ANY_SOURCE: 400,
					ALLIANZ: 90,
					ALOL_TNT_APP: 95,
					ANDROID_APP: 120,
					BACKOFFICE_SUPER_ADMIN_CALL: 110,
					BACKOFFICE_SUPER_ADMIN_FLOW: 78,
					BME: 85,
				},
				{
					name: "2025-05-02",
					WIDGET_ONLINE: 488,
					ANY_SOURCE: 230,
					ALLIANZ: 110,
					ALOL_TNT_APP: 102,
					ANDROID_APP: 111,
					BACKOFFICE_SUPER_ADMIN_CALL: 130,
					BACKOFFICE_SUPER_ADMIN_FLOW: 91,
					BME: 96,
				},
				{
					name: "2025-05-03",
					WIDGET_ONLINE: 577,
					ANY_SOURCE: 377,
					ALLIANZ: 98,
					ALOL_TNT_APP: 130,
					ANDROID_APP: 93,
					BACKOFFICE_SUPER_ADMIN_CALL: 89,
					BACKOFFICE_SUPER_ADMIN_FLOW: 105,
					BME: 77,
				},
				{
					name: "2025-05-04",
					WIDGET_ONLINE: 365,
					ANY_SOURCE: 120,
					ALLIANZ: 105,
					ALOL_TNT_APP: 79,
					ANDROID_APP: 135,
					BACKOFFICE_SUPER_ADMIN_CALL: 120,
					BACKOFFICE_SUPER_ADMIN_FLOW: 100,
					BME: 103,
				},
				{
					name: "2025-05-05",
					WIDGET_ONLINE: 429,
					ANY_SOURCE: 208,
					ALLIANZ: 123,
					ALOL_TNT_APP: 118,
					ANDROID_APP: 128,
					BACKOFFICE_SUPER_ADMIN_CALL: 101,
					BACKOFFICE_SUPER_ADMIN_FLOW: 95,
					BME: 84,
				},
			],
		},
	})

export const getGetAppointmentsKpiDataResponseMock =
	(): AppointmentsKpiResponse => ({
		period: {
			startDate: "2025-05-01",
			endDate: "2025-05-07",
			detalization: "day",
		},
		commonStat: [
			{ title: "analytics.kpi.widgetOpened", rawValue: 1200, trendValue: 12.5 },
			{
				title: "analytics.kpi.reserveSuccess",
				rawValue: 1100,
				trendValue: 12.5,
				percent: 75,
			},
			{
				title: "analytics.kpi.appointmentCreated",
				rawValue: 850,
				trendValue: 12.5,
				percent: 50,
			},
		],
		chart: {
			title: "analytics.appointmentsKpi.chart.title",
			legend: [
				{
					name: "analytics.legend.widgetOpened",
					key: "widgetOpened",
					color: "#22c55e",
				},
				{
					name: "analytics.legend.reserveSuccess",
					key: "reserveSuccess",
					color: "#3b82f6",
				},
				{
					name: "analytics.legend.appointmentCreated",
					key: "appointmentCreated",
					color: "#f87171",
				},
			],
			data: [
				{
					name: "2025-04-02",
					widgetOpened: 100,
					reserveSuccess: 80,
					appointmentCreated: 60,
				},
				{
					name: "2025-04-08",
					widgetOpened: 120,
					reserveSuccess: 100,
					appointmentCreated: 80,
				},
				{
					name: "2025-04-14",
					widgetOpened: 150,
					reserveSuccess: 130,
					appointmentCreated: 100,
				},
			],
		},
	})

export const getGetGeneralAppointmentsDataResponseMock =
	(): GeneralAppointmentsResponse => ({
		period: { startDate: "2025-05-01", endDate: "2025-05-07" },
		commonStat: [
			{
				type: "created",
				title: "analytics.general.cards.created",
				rawValue: 3000,
				trendValue: 12.5,
				onlineRaw: 2500,
			},
			{
				type: "confirmed",
				title: "analytics.general.cards.confirmed",
				rawValue: 1250,
				trendValue: 8.3,
				clientRaw: 1000,
				adminRaw: 250,
			},
			{
				type: "cancelled",
				title: "analytics.general.cards.cancelled",
				rawValue: 1000,
				trendValue: -5.2,
				clientRaw: 500,
				adminRaw: 500,
			},
			{
				type: "reviews",
				title: "analytics.general.cards.reviews",
				rawValue: 150,
				trendValue: 15.4,
				avgRating: 4.5,
				sentRaw: 500,
			},
		],
		table: {
			columns: [
				{
					key: "branch",
					label: "analytics.general.columns.branch",
					align: "left",
				},
				{
					key: "created",
					label: "analytics.general.columns.created",
					align: "right",
				},
				{
					key: "confirmed",
					label: "analytics.general.columns.confirmed",
					align: "right",
				},
				{
					key: "cancelled",
					label: "analytics.general.columns.cancelled",
					align: "right",
				},
				{
					key: "reviewsReceived",
					label: "analytics.general.columns.reviewsReceived",
					align: "right",
				},
			],
			data: [
				{
					branch: "Филиал 1, г. Омск",
					created: "600",
					confirmed: "200",
					cancelled: "200",
					reviewsReceived: "30",
					rawValues: {
						created: 600,
						confirmed: 200,
						cancelled: 200,
						reviewsReceived: 30,
					},
				},
				{
					branch: "Филиал 2, г. Москва",
					created: "600",
					confirmed: "250",
					cancelled: "200",
					reviewsReceived: "30",
					rawValues: {
						created: 600,
						confirmed: 250,
						cancelled: 200,
						reviewsReceived: 30,
					},
				},
				{
					branch: "Филиал 3, г. Санкт-Петербург",
					created: "600",
					confirmed: "300",
					cancelled: "200",
					reviewsReceived: "30",
					rawValues: {
						created: 600,
						confirmed: 300,
						cancelled: 200,
						reviewsReceived: 30,
					},
				},
				{
					branch: "Филиал 4, г. Казань",
					created: "600",
					confirmed: "250",
					cancelled: "200",
					reviewsReceived: "30",
					rawValues: {
						created: 600,
						confirmed: 250,
						cancelled: 200,
						reviewsReceived: 30,
					},
				},
				{
					branch: "Филиал 5, г. Екатеринбург",
					created: "600",
					confirmed: "200",
					cancelled: "200",
					reviewsReceived: "30",
					rawValues: {
						created: 600,
						confirmed: 200,
						cancelled: 200,
						reviewsReceived: 30,
					},
				},
			],
			summary: {
				branch: "Итого",
				created: "3000",
				confirmed: "1250",
				cancelled: "1000",
				reviewsReceived: "150",
				rawValues: {
					created: 3000,
					confirmed: 1250,
					cancelled: 1000,
					reviewsReceived: 150,
				},
			},
		},
	})

export const getGetWidgetFunnelDataMockHandler = (
	overrideResponse?:
		| WidgetFunnelResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<WidgetFunnelResponse> | WidgetFunnelResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/analytics/widget-conversion",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGetWidgetFunnelDataResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getGetReviewsFunnelDataMockHandler = (
	overrideResponse?:
		| ReviewsFunnelResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<ReviewsFunnelResponse> | ReviewsFunnelResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/analytics/reviews-conversion",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGetReviewsFunnelDataResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getGetAppointmentConfirmationDataMockHandler = (
	overrideResponse?:
		| AppointmentConfirmationResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) =>
				| Promise<AppointmentConfirmationResponse>
				| AppointmentConfirmationResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/analytics/appointment-confirmation",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGetAppointmentConfirmationDataResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getGetBookingSourcesDataMockHandler = (
	overrideResponse?:
		| BookingSourcesResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<BookingSourcesResponse> | BookingSourcesResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/analytics/booking-sources",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGetBookingSourcesDataResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getGetAppointmentsKpiDataMockHandler = (
	overrideResponse?:
		| AppointmentsKpiResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<AppointmentsKpiResponse> | AppointmentsKpiResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/analytics/appointments-kpi",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGetAppointmentsKpiDataResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getGetGeneralAppointmentsDataMockHandler = (
	overrideResponse?:
		| GeneralAppointmentsResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<GeneralAppointmentsResponse> | GeneralAppointmentsResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/analytics/general-appointments",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGetGeneralAppointmentsDataResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getSaveAnalyticsEventMockHandler = (
	overrideResponse?:
		| void
		| ((
				info: Parameters<Parameters<typeof http.post>[1]>[0],
		  ) => Promise<void> | void),
	options?: RequestHandlerOptions,
) => {
	return http.post(
		"*/analytics/events",
		async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
			await delay(300)
			if (typeof overrideResponse === "function") {
				await overrideResponse(info)
			}

			return new HttpResponse(null, { status: 201 })
		},
		options,
	)
}
export const getAnalyticsMock = () => [
	getGetWidgetFunnelDataMockHandler(),
	getGetReviewsFunnelDataMockHandler(),
	getGetAppointmentConfirmationDataMockHandler(),
	getGetBookingSourcesDataMockHandler(),
	getGetAppointmentsKpiDataMockHandler(),
	getGetGeneralAppointmentsDataMockHandler(),
	getSaveAnalyticsEventMockHandler(),
]
